<h2 mat-dialog-title>Really delete <em>{{ data.title }}</em>?</h2>
<mat-dialog-content>
    <p>The record of this book will be permanently deleted.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close aria-label="cancel deleting {{ data.title }}">Cancel</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial aria-label="delete {{ data.title }}">Delete book</button>
</mat-dialog-actions>